<div class="page-container reserve-add-content">
  <!-- 企業預約載入畫面 -->
  @if (isLoadingBusinessSuggestions || isLoadingPersonalSuggestions) {
  <div class="reserve-loading-container">
    <img width="28" height="28" ngSrc="assets/img/img-loadingAI.png" alt="Loading Image" class="loading-image" />
    <h2>載入加選中</h2>
    <div class="dot-loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
    @if (showCountdown&&!isAddItemTimeout) {
      <p class="countdown-text">
        同時在線使用人數過多， 預估等待時間
        <span class="countdown-number">{{ addItemCountdown }}</span> 秒
      </p>
    }

    @if (isAddItemTimeout) {
      <p class="timeout-text"> 同時在線使用人數過，請點選下方按鈕重新嘗試</p>
      <button class="btn-refresh" (click)="retryLoadAddItem()">重新整理</button>
    }
  </div>
  } @else {
  <div class="reserve-add-left-page" #reserveAddLeftPage>

    <div class="header-block">
      <h3 class="page-title">{{ 'reserve-add.title' | translate }}</h3>
      <p class="page-subtitle">{{ 'reserve-add.subtitle-1' | translate }}</p>
      <app-text size="reserve-add" weight="s" color="gray-500">{{ 'reserve-add.p-text-1' | translate }}</app-text>
      <app-text size="reserve-add" weight="s" color="gray-500">{{ 'reserve-add.p-text-2' | translate }}</app-text>
    </div>

    @if ((selectedPackage !== '全面掌握型' && !isFromMemberCenter)) {
    <!-- tab 區域 -->
    <div class="tab-block">
      <div class="tab-header-wrapper">
        <mat-tab-group [(selectedIndex)]="selectedTab" class="reserve-add-tab-group">
          <mat-tab label="依風險排列"></mat-tab>
          <mat-tab label="尋找檢查項目"></mat-tab>
        </mat-tab-group>
        <!-- <button mat-button class="btn-text-primary view-mode-btn">
              <img width="14" height="14" ngSrc="assets/img/tab-change.png" alt="" />
              <span>{{ 'reserve-add.view-mode' | translate }}</span>
            </button> -->
      </div>
      @if (selectedTab === 0) {
      @if(sharedStorageService.get('reserveType')===ID_LOGIN_TYPE.ENTERPRISE && medicalAbnormalExams.length > 0){
      <div class="risk-view-content">
        <div class="risk-medical-card">
          <div class="risk-view-header">
            <span class="risk-medical-tag first">醫學評估基礎項目</span>
          </div>
          <div class="subtitle-block strongest-suggestion">
            <p>．您目前的企業方案未包含以下基礎檢查項目，可依需求自行加選</p>

          </div>

        </div>
        <div class="button-group strongest-suggestion-group">
          <button mat-button class="btn-fill-primary btn-size-s" (click)="getAllmedicalAbnormalExams()"
            [disabled]="isAllMedicalAbnormalExamsAdded">
            <img width="18" height="18" ngSrc="assets/img/plus-icon.png" alt="" />
            {{ "reserve-add.all-in" | translate }}
          </button>
          <p class="count">已選 <span class="count-number" [class.zero]="selectedMidAbnormalCount === 0">{{
              selectedMedicalAbnormalCount }}</span> / {{ totalMedicalAbnormalCount }} 項</p>
        </div>
        <div class="reserve-add-card-block">
          @for (examInfo of (isMedicalExamsExpanded ? medicalAbnormalExams : medicalAbnormalExams.slice(0, 1)); track $index) {
          @let triggeredBys = examInfo.triggeredBys;
          <div class="reserve-plan-card" [ngClass]="{
                          active:
                            checkedExamItemSet.has(examInfo.examItem) ||
                            checkedExamItemListUnderPackage.includes(examInfo.examItem),
                          disabled: mutexInfos.has(examInfo.examItem),
                          'active-disabled': isActiveDisabled(
                            examInfo.examItem,
                            examInfo.examType
                          ),
                        }" (click)="
                          !mutexInfos.has(examInfo.examItem) &&
                            toggleChecked(
                              !checkedExamItemSet.has(examInfo.examItem) &&
                                !checkedExamItemListUnderPackage.includes(examInfo.examItem),
                              examInfo
                            )
                          ">
            <!-- 卡牌標題 -->
            <div class="reserve-plan-title">
              <!-- 卡牌checkbox -->
              <div class="reserve-price-block">
                @if (sharedStorageService.get('reserveType') === '1') {
                <!-- 個人預約：非必要檢項或方案內非標準檢項都顯示 checkbox -->
                @if (!examInfo.isNecessary || (examInfo.isNecessary && !examInfo.isChoice && !isFromMemberCenter)) {
                <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                  (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                    checkedExamItemSet.has(examInfo.examItem) ||
                                    checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                  " (click)="$event.stopPropagation()" [ngClass]="{
                                    'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                  }">
                </mat-checkbox>
                }
                } @else if (sharedStorageService.get('reserveType') === '2') {
                <!-- 企業預約：非方案內檢項顯示 checkbox -->
                @if (!isExamInPackage(examInfo.examItem)) {
                <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                  (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                    checkedExamItemSet.has(examInfo.examItem) ||
                                    checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                  " (click)="$event.stopPropagation()" [ngClass]="{
                                    'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                  }">
                </mat-checkbox>
                }
                }
              </div>

              <div class="title-with-tag">
                <h2>{{ examInfo.examName }}</h2>
                @if (isAbnormalExam(examInfo.examItem)) {
                <app-tag size="reserveAdd" color="outline-red">
                  <app-text size="xxs" weight="m" color="red-600">個人歷史異常</app-text>
                </app-tag>
                }
                @if (mutexInfos.has(examInfo.examItem)) {
                <app-tag size="reserveAdd" color="outline-gray">
                  <app-text size="xxs" weight="m" color="gray-700">檢查意義重複</app-text>
                </app-tag>
                }
                <!-- 調價表tag -->
                @if (isPriceChangeExam(examInfo.examItem)) {
                  <app-tag size="reserveAdd" color="outline-steel">
                    <app-text size="xxs" weight="m" color="steel-500">即將調漲</app-text>
                  </app-tag>
                }
              </div>

              <p class="reserve-plan-price">
                @if (!isExamInPackage(examInfo.examItem)) {
                <label>NT$</label>
                {{ examInfo.discountedPrice | numberComma }}
                }@else if (isExamInPackage(examInfo.examItem)) {
                <span class="package-price-text">方案價</span>
                }
              </p>
            </div>

            <!-- 卡片標籤 -->
            <div class="reserve-plan-tag">
              @for (tag of (triggeredBys ?? []); track tag.tagName) {
              <app-tag size="xs"
                [color]="tag.tagColor === '1' ? 'outline-red' : tag.tagColor === '2' ? 'outline-purple' : 'outline-blue'"
                style="margin: 5px;">
                <app-text size="s" weight="m"
                  [color]="tag.tagColor === '1' ? 'red-600' : tag.tagColor === '2' ? 'purple-500' : 'blue-500'">{{tag.tagName}}</app-text>
              </app-tag>
              }
            </div>
            <div class="reserve-plan-memo-wrapper">
              <p class="reserve-plan-memo" [class.expanded]="expandedMemos.has(examInfo.examItem)"   [class.no-tag]="!triggeredBys?.length"
                [matTooltip]="!isMobile && !expandedMemos.has(examInfo.examItem) && shouldShowReadMore(examInfo.examItem, memoElement) ? examInfo.examMemo : ''"
                [matTooltipDisabled]="isMobile" matTooltipPosition="above" matTooltipClass="memo-tooltip" #memoElement>
                {{ examInfo.examMemo }}
              </p>
              @if (shouldShowReadMore(examInfo.examItem, memoElement)) {
              <button mat-button class="read-more-btn" (click)="toggleMemo($event, examInfo.examItem)">
                <app-text size="special" weight="m" color="primary-700">
                  閱讀更多
                </app-text>
                <img [src]="expandedMemos.has(examInfo.examItem) ? 
                                  'assets/img/arrow-up.png' : 
                                  'assets/img/arrow-down.png'" alt="toggle" width="11" height="11" />
              </button>
              }
            </div>
          </div>

          }
          @if (medicalAbnormalExams.length > 1) {
          <div class="expand-more-block"  (click)="isMedicalExamsExpanded = !isMedicalExamsExpanded">
            <app-text size="special2" weight="m" color="primary-700">
              {{ isMedicalExamsExpanded ? '收合' : '顯示全部' }}
            </app-text>
            <img [src]="isMedicalExamsExpanded ? 'assets/img/arrow-up.png' : 'assets/img/arrow-down.png'"
              alt="toggle" width="18" height="18" />
          </div>
          }
        </div>
      </div>
      }

      <div class="risk-view-content">
        <div class="risk-strong-card">
          <div class="risk-view-header">
            <span class="risk-view-tag first">{{ 'reserve-add.risk-strongest-suggestion' | translate }}</span>
          </div>
          <div class="subtitle-block strongest-suggestion">
            @if (hasAbnormalData) {
            <p class="risk-view-subtitle">{{ 'reserve-add.risk-strongest-suggestion-subtitle-1' | translate }}
              }
            <p class="risk-view-subtitle">{{ 'reserve-add.risk-strongest-suggestion-subtitle-2' | translate }}</p>

          </div>
        </div>
        <div class="button-group strongest-suggestion-group">
          <button mat-button class="btn-fill-primary btn-size-s" (click)="getAllAbnormalExams()"
            [disabled]="isAllHighAbnormalExamsAdded">
            <img width="18" height="18" ngSrc="assets/img/plus-icon.png" alt="" />
            {{ "reserve-add.all-in" | translate }}
          </button>
          <p class="count">已選 <span class="count-number" [class.zero]="selectedHighAbnormalCount === 0">{{
              selectedHighAbnormalCount }}</span> / {{ totalHighAbnormalCount }} 項</p>
        </div>

        <div class="reserve-add-card-block">
          @for (examInfo of combinedHighAbnormalExams; track examInfo.examItem) {
          @let triggeredBys = examInfo.triggeredBys;
          <div class="reserve-plan-card" [ngClass]="{
                          active:
                            checkedExamItemSet.has(examInfo.examItem) ||
                            checkedExamItemListUnderPackage.includes(examInfo.examItem),
                          disabled: mutexInfos.has(examInfo.examItem),
                          'active-disabled': isActiveDisabled(
                            examInfo.examItem,
                            examInfo.examType
                          ),
                        }" (click)="
                          !mutexInfos.has(examInfo.examItem) &&
                            toggleChecked(
                              !checkedExamItemSet.has(examInfo.examItem) &&
                                !checkedExamItemListUnderPackage.includes(examInfo.examItem),
                              examInfo
                            )
                          ">
            <!-- 卡牌標題 -->
            <div class="reserve-plan-title">
              <!-- 卡牌checkbox -->
              <div class="reserve-price-block">
                @if (sharedStorageService.get('reserveType') === '1') {
                <!-- 個人預約：非必要檢項或方案內非標準檢項都顯示 checkbox -->
                @if (!examInfo.isNecessary || (examInfo.isNecessary && !examInfo.isChoice && !isFromMemberCenter)) {
                <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                  (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                    checkedExamItemSet.has(examInfo.examItem) ||
                                    checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                  " (click)="$event.stopPropagation()" [ngClass]="{
                                    'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                  }">
                </mat-checkbox>
                }
                } @else if (sharedStorageService.get('reserveType') === '2') {
                <!-- 企業預約：非方案內檢項顯示 checkbox -->
                @if (!isExamInPackage(examInfo.examItem)) {
                <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                  (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                    checkedExamItemSet.has(examInfo.examItem) ||
                                    checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                  " (click)="$event.stopPropagation()" [ngClass]="{
                                    'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                  }">
                </mat-checkbox>
                }
                }
              </div>

              <div class="title-with-tag">
                <h2>{{ examInfo.examName }}</h2>
                @if (isAbnormalExam(examInfo.examItem)) {
                <app-tag size="reserveAdd" color="outline-red">
                  <app-text size="xxs" weight="m" color="red-600">個人歷史異常</app-text>
                </app-tag>
                }
                @if (mutexInfos.has(examInfo.examItem)) {
                <app-tag size="reserveAdd" color="outline-gray">
                  <app-text size="xxs" weight="m" color="gray-700">檢查意義重複</app-text>
                </app-tag>
                }
                <!-- 調價表tag -->
                @if (isPriceChangeExam(examInfo.examItem)) {
                  <app-tag size="reserveAdd" color="outline-steel">
                    <app-text size="xxs" weight="m" color="steel-500">即將調漲</app-text>
                  </app-tag>
                }
              </div>

              <p class="reserve-plan-price">
                @if (!isExamInPackage(examInfo.examItem)) {
                <label>NT$</label>
                {{ examInfo.discountedPrice | numberComma }}
                }@else if (isExamInPackage(examInfo.examItem)) {
                <span class="package-price-text">方案價</span>
                }
              </p>
            </div>
            <!-- 卡片標籤 -->
            <div class="reserve-plan-tag">
              @for (tag of (triggeredBys ?? []); track tag.tagName) {
              <app-tag size="xs"
                [color]="tag.tagColor === '1' ? 'outline-red' : tag.tagColor === '2' ? 'outline-purple' : 'outline-blue'"
                style="margin: 5px;">
                <app-text size="s" weight="m"
                  [color]="tag.tagColor === '1' ? 'red-600' : tag.tagColor === '2' ? 'purple-500' : 'blue-500'">{{tag.tagName}}</app-text>
              </app-tag>
              }
            </div>
            <div class="reserve-plan-memo-wrapper">
              <p class="reserve-plan-memo" [class.expanded]="expandedMemos.has(examInfo.examItem)"   [class.no-tag]="!triggeredBys?.length"
                [matTooltip]="!isMobile && !expandedMemos.has(examInfo.examItem) && shouldShowReadMore(examInfo.examItem, memoElement) ? examInfo.examMemo : ''"
                [matTooltipDisabled]="isMobile" matTooltipPosition="above" matTooltipClass="memo-tooltip" #memoElement>
                {{ examInfo.examMemo }}
              </p>
              @if (shouldShowReadMore(examInfo.examItem, memoElement)) {
              <button mat-button class="read-more-btn" (click)="toggleMemo($event, examInfo.examItem)">
                <app-text size="special" weight="m" color="primary-700">
                  閱讀更多
                </app-text>
                <img [src]="expandedMemos.has(examInfo.examItem) ? 
                                  'assets/img/arrow-up.png' : 
                                  'assets/img/arrow-down.png'" alt="toggle" width="11" height="11" />
              </button>
              }
            </div>
          </div>

          }
        </div>
      </div>

      <div class="risk-view-content">
        <div class="risk-middle-card">
          <div class="risk-view-header">
            <span class="risk-view-tag first">提前關注的項目</span>
          </div>
          <div class="subtitle-block strongest-suggestion">
            <p class="risk-view-subtitle">{{ 'reserve-add.risk-view-2-subtitle' | translate }}</p>

          </div>

        </div>
        <div class="button-group strongest-suggestion-group">
          <button mat-button class="btn-fill-primary btn-size-s" (click)="getAllMidAbnormalExams()"
            [disabled]="isAllMidAbnormalExamsAdded">
            <img width="18" height="18" ngSrc="assets/img/plus-icon.png" alt="" />
            {{ "reserve-add.all-in" | translate }}
          </button>
          <p class="count">已選 <span class="count-number" [class.zero]="selectedMidAbnormalCount === 0">{{
              selectedMidAbnormalCount }}</span> / {{ totalMidAbnormalCount }} 項</p>
        </div>
        <div class="reserve-add-card-block">
          @for (examInfo of basicCheckupMidAbnormalExams; track examInfo.examItem) {
          @let triggeredBys = examInfo.triggeredBys;
          <div class="reserve-plan-card" [ngClass]="{
                          active:
                            checkedExamItemSet.has(examInfo.examItem) ||
                            checkedExamItemListUnderPackage.includes(examInfo.examItem),
                          disabled: mutexInfos.has(examInfo.examItem),
                          'active-disabled': isActiveDisabled(
                            examInfo.examItem,
                            examInfo.examType
                          ),
                        }" (click)="
                          !mutexInfos.has(examInfo.examItem) &&
                            toggleChecked(
                              !checkedExamItemSet.has(examInfo.examItem) &&
                                !checkedExamItemListUnderPackage.includes(examInfo.examItem),
                              examInfo
                            )
                          ">
            <!-- 卡牌標題 -->
            <div class="reserve-plan-title">
              <!-- 卡牌checkbox -->
              <div class="reserve-price-block">
                @if (sharedStorageService.get('reserveType') === '1') {
                <!-- 個人預約：非必要檢項或方案內非標準檢項都顯示 checkbox -->
                @if (!examInfo.isNecessary || (examInfo.isNecessary && !examInfo.isChoice && !isFromMemberCenter)) {
                <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                  (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                    checkedExamItemSet.has(examInfo.examItem) ||
                                    checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                  " (click)="$event.stopPropagation()" [ngClass]="{
                                    'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                  }">
                </mat-checkbox>
                }
                } @else if (sharedStorageService.get('reserveType') === '2') {
                <!-- 企業預約：非方案內檢項顯示 checkbox -->
                @if (!isExamInPackage(examInfo.examItem)) {
                <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                  (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                    checkedExamItemSet.has(examInfo.examItem) ||
                                    checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                  " (click)="$event.stopPropagation()" [ngClass]="{
                                    'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                  }">
                </mat-checkbox>
                }
                }
              </div>

              <div class="title-with-tag">
                <h2>{{ examInfo.examName }}</h2>
                @if (isAbnormalExam(examInfo.examItem)) {
                <app-tag size="reserveAdd" color="outline-red">
                  <app-text size="xxs" weight="m" color="red-600">個人歷史異常</app-text>
                </app-tag>
                }
                @if (mutexInfos.has(examInfo.examItem)) {
                <app-tag size="reserveAdd" color="outline-gray">
                  <app-text size="xxs" weight="m" color="gray-700">檢查意義重複</app-text>
                </app-tag>
                }
                <!-- 調價表tag -->
                @if (isPriceChangeExam(examInfo.examItem)) {
                  <app-tag size="reserveAdd" color="outline-steel">
                    <app-text size="xxs" weight="m" color="steel-500">即將調漲</app-text>
                  </app-tag>
                }
              </div>

              <p class="reserve-plan-price">
                @if (!isExamInPackage(examInfo.examItem)) {
                <label>NT$</label>
                {{ examInfo.discountedPrice | numberComma }}
                }@else if (isExamInPackage(examInfo.examItem)) {
                <span class="package-price-text">方案價</span>
                }
              </p>
            </div>

            <!-- 卡片標籤 -->
            <div class="reserve-plan-tag">
              @for (tag of (triggeredBys ?? []); track tag.tagName) {
              <app-tag size="xs"
                [color]="tag.tagColor === '1' ? 'outline-red' : tag.tagColor === '2' ? 'outline-purple' : 'outline-blue'"
                style="margin: 5px;">
                <app-text size="s" weight="m"
                  [color]="tag.tagColor === '1' ? 'red-600' : tag.tagColor === '2' ? 'purple-500' : 'blue-500'">{{tag.tagName}}</app-text>
              </app-tag>
              }
            </div>
            <div class="reserve-plan-memo-wrapper">
              <p class="reserve-plan-memo" [class.expanded]="expandedMemos.has(examInfo.examItem)"   [class.no-tag]="!triggeredBys?.length"
                [matTooltip]="!isMobile && !expandedMemos.has(examInfo.examItem) && shouldShowReadMore(examInfo.examItem, memoElement) ? examInfo.examMemo : ''"
                [matTooltipDisabled]="isMobile" matTooltipPosition="above" matTooltipClass="memo-tooltip" #memoElement>
                {{ examInfo.examMemo }}

              </p>
              @if (shouldShowReadMore(examInfo.examItem, memoElement)) {
              <button mat-button class="read-more-btn" (click)="toggleMemo($event, examInfo.examItem)">
                <app-text size="special" weight="m" color="primary-700">
                  閱讀更多
                </app-text>
                <img [src]="expandedMemos.has(examInfo.examItem) ? 
                                  'assets/img/arrow-up.png' : 
                                  'assets/img/arrow-down.png'" alt="toggle" width="11" height="11" />
              </button>
              }
            </div>
          </div>

          }
        </div>
      </div>

      <div class="risk-view-content">
        <div class="risk-low-card">

          <div class="risk-view-header">
            <span class="risk-view-tag first">主動預防的項目</span>
          </div>
          <div class="subtitle-block strongest-suggestion">
            <p class="risk-view-subtitle">{{ 'reserve-add.risk-view-3-subtitle' | translate }}</p>

          </div>
        </div>
        <div class="button-group strongest-suggestion-group">
          <button mat-button class="btn-fill-primary btn-size-s" (click)="getAllLowAbnormalExams()"
            [disabled]="isAllLowAbnormalExamsAdded">
            <img width="18" height="18" ngSrc="assets/img/plus-icon.png" alt="" />
            {{ "reserve-add.all-in" | translate }}
          </button>
          <p class="count">已選 <span class="count-number" [class.zero]="selectedLowAbnormalCount === 0">{{
              selectedLowAbnormalCount }}</span> / {{ totalLowAbnormalCount }} 項</p>
        </div>
        <div class="reserve-add-card-block">
          @for (examInfo of basicCheckupLowAbnormalExams; track examInfo.examItem) {
          @let triggeredBys = examInfo.triggeredBys;
          <div class="reserve-plan-card" [ngClass]="{
                          active:
                            checkedExamItemSet.has(examInfo.examItem) ||
                            checkedExamItemListUnderPackage.includes(examInfo.examItem),
                          disabled: mutexInfos.has(examInfo.examItem),
                          'active-disabled': isActiveDisabled(
                            examInfo.examItem,
                            examInfo.examType
                          ),
                        }" (click)="
                          !mutexInfos.has(examInfo.examItem) &&
                            toggleChecked(
                              !checkedExamItemSet.has(examInfo.examItem) &&
                                !checkedExamItemListUnderPackage.includes(examInfo.examItem),
                              examInfo
                            )
                          ">
            <!-- 卡牌標題 -->
            <div class="reserve-plan-title">
              <!-- 卡牌checkbox -->
              <div class="reserve-price-block">
                @if (sharedStorageService.get('reserveType') === '1') {
                <!-- 個人預約：非必要檢項或方案內非標準檢項都顯示 checkbox -->
                @if (!examInfo.isNecessary || (examInfo.isNecessary && !examInfo.isChoice && !isFromMemberCenter)) {
                <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                  (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                    checkedExamItemSet.has(examInfo.examItem) ||
                                    checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                  " (click)="$event.stopPropagation()" [ngClass]="{
                                    'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                  }">
                </mat-checkbox>
                }
                } @else if (sharedStorageService.get('reserveType') === '2') {
                <!-- 企業預約：非方案內檢項顯示 checkbox -->
                @if (!isExamInPackage(examInfo.examItem)) {
                <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                  (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                    checkedExamItemSet.has(examInfo.examItem) ||
                                    checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                  " (click)="$event.stopPropagation()" [ngClass]="{
                                    'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                  }">
                </mat-checkbox>
                }
                }
              </div>

              <div class="title-with-tag">
                <h2>{{ examInfo.examName }}</h2>
                @if (isAbnormalExam(examInfo.examItem)) {
                <app-tag size="reserveAdd" color="outline-red">
                  <app-text size="xxs" weight="m" color="red-600">個人歷史異常</app-text>
                </app-tag>
                }
                @if (mutexInfos.has(examInfo.examItem)) {
                <app-tag size="reserveAdd" color="outline-gray">
                  <app-text size="xxs" weight="m" color="gray-700">檢查意義重複</app-text>
                </app-tag>
                }
                <!-- 調價表tag -->
                @if (isPriceChangeExam(examInfo.examItem)) {
                  <app-tag size="reserveAdd" color="outline-steel">
                    <app-text size="xxs" weight="m" color="steel-500">即將調漲</app-text>
                  </app-tag>
                }
              </div>

              <p class="reserve-plan-price">
                @if (!isExamInPackage(examInfo.examItem)) {
                <label>NT$</label>
                {{ examInfo.discountedPrice | numberComma }}
                }@else if (isExamInPackage(examInfo.examItem)) {
                <span class="package-price-text">方案價</span>
                }
              </p>
            </div>
            <!-- 卡片標籤 -->
            <div class="reserve-plan-tag">
              @for (tag of (triggeredBys ?? []); track tag.tagName) {
              <app-tag size="xs"
                [color]="tag.tagColor === '1' ? 'outline-red' : tag.tagColor === '2' ? 'outline-purple' : 'outline-blue'"
                style="margin: 5px;">
                <app-text size="s" weight="m"
                  [color]="tag.tagColor === '1' ? 'red-600' : tag.tagColor === '2' ? 'purple-500' : 'blue-500'">{{tag.tagName}}</app-text>
              </app-tag>
              }
            </div>
            <div class="reserve-plan-memo-wrapper">
              <p class="reserve-plan-memo" [class.expanded]="expandedMemos.has(examInfo.examItem)"  [class.no-tag]="!triggeredBys?.length"
                [matTooltip]="!isMobile && !expandedMemos.has(examInfo.examItem) && shouldShowReadMore(examInfo.examItem, memoElement) ? examInfo.examMemo : ''"
                [matTooltipDisabled]="isMobile" matTooltipPosition="above" matTooltipClass="memo-tooltip" #memoElement>
                {{ examInfo.examMemo }}

              </p>
              @if (shouldShowReadMore(examInfo.examItem, memoElement)) {
              <button mat-button class="read-more-btn" (click)="toggleMemo($event, examInfo.examItem)">
                <app-text size="special" weight="m" color="primary-700">
                  閱讀更多
                </app-text>
                <img [src]="expandedMemos.has(examInfo.examItem) ? 
                                  'assets/img/arrow-up.png' : 
                                  'assets/img/arrow-down.png'" alt="toggle" width="11" height="11" />
              </button>
              }
            </div>
          </div>
          }
        </div>
      </div>



      } @else if (selectedTab === 1) {

      <div class="reserve-add-search-block">
        <div class="input-group input-btn-left">
          <input [placeholder]="'reserve-add.quick-search-placeholder' | translate" [(ngModel)]="quickSearchText"
            (ngModelChange)="quickSearchWithText()" />
          <button mat-icon-button type="button" class="input-search-btn">
            <img width="24" height="24" ngSrc="assets/img/i-search-b.svg" alt="" />
          </button>
        </div>

        <div class="input-block">
          <div class="custom-multi-select" [class.open]="isDeptFilterOpen">
            <div class="select-trigger" (click)="toggleDeptFilter()">
              <span class="placeholder">分類篩選</span>
              <div class="trigger-right">
                @if (selectedDeptNames.length > 0) {
                <span class="selected-count">{{ selectedDeptNames.length }}</span>
                }
                <img width="24" height="24"
                  [ngSrc]="isDeptFilterOpen ? 'assets/img/i-arrow-up.svg' : 'assets/img/i-arrow-down.svg'" alt="" />
              </div>
            </div>

            @if (isDeptFilterOpen) {
            <div class="select-dropdown">
              <div class="select-header">
                <button mat-button class="clear-all-btn" (click)="clearAllDeptFilters()">
                  全部清除
                </button>
              </div>

              <div class="select-options">
                @for (deptName of quickSearchDeptNames; track i; let i = $index) {
                <div class="select-option">
                  <mat-checkbox [checked]="selectedDeptNames.includes(deptName)"
                    (change)="toggleDeptFilter(deptName, $event.checked)">
                    {{ deptName }}
                  </mat-checkbox>
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- 方案卡片區域 -->
      <div class="reserve-add-card-block">

        @for (deptName of quickSearchDeptNames; track i; let i = $index) {
        @let deptExams = getExamInfosByDeptName(deptName);
        @let visibleExams = getVisibleExams(deptExams);
        @if (visibleExams.length > 0 && (selectedDeptNames.length === 0 || selectedDeptNames.includes(deptName))) {
        <div class="reserve-add-category-header">{{ deptName }}</div>
        @for (examInfo of visibleExams; track examInfo.examItem) {
        <div class="reserve-plan-card" [ngClass]="{
                        active:
                          checkedExamItemSet.has(examInfo.examItem) ||
                          checkedExamItemListUnderPackage.includes(examInfo.examItem),
                        disabled: mutexInfos.has(examInfo.examItem),
                        'active-disabled': isActiveDisabled(
                          examInfo.examItem,
                          examInfo.examType
                        ),
                      }" (click)="
                        !mutexInfos.has(examInfo.examItem) &&
                          toggleChecked(
                            !checkedExamItemSet.has(examInfo.examItem) &&
                              !checkedExamItemListUnderPackage.includes(examInfo.examItem),
                            examInfo
                          )
                        ">
          <!-- 卡牌標題 -->
          <div class="reserve-plan-title">
            <!-- 卡牌checkbox -->
            <div class="reserve-price-block">
              @if (sharedStorageService.get('reserveType') === '1') {
              <!-- 個人預約：非必要檢項或方案內非標準檢項都顯示 checkbox -->
              @if (!examInfo.isNecessary || (examInfo.isNecessary && !examInfo.isChoice && !isFromMemberCenter)) {
              <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                  checkedExamItemSet.has(examInfo.examItem) ||
                                  checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                " (click)="$event.stopPropagation()" [ngClass]="{
                                  'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                }">
              </mat-checkbox>
              }
              } @else if (sharedStorageService.get('reserveType') === '2') {
              <!-- 企業預約：非方案內檢項顯示 checkbox -->
              @if (!isExamInPackage(examInfo.examItem)) {
              <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
                (change)="toggleChecked($event.checked, examInfo)" [checked]="
                                  checkedExamItemSet.has(examInfo.examItem) ||
                                  checkedExamItemListUnderPackage.includes(examInfo.examItem)
                                " (click)="$event.stopPropagation()" [ngClass]="{
                                  'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                                }">
              </mat-checkbox>
              }
              }
            </div>

            <div class="title-with-tag">
              <h2>{{ examInfo.examName }}</h2>
              @if (isAbnormalExam(examInfo.examItem)) {
              <app-tag size="reserveAdd" color="outline-red">
                <app-text size="xxs" weight="m" color="red-600">個人歷史異常</app-text>
              </app-tag>
              }
              @if (mutexInfos.has(examInfo.examItem)) {
              <app-tag size="reserveAdd" color="outline-gray">
                <app-text size="xxs" weight="m" color="gray-700">檢查意義重複</app-text>
              </app-tag>
              }
              <!-- 調價表tag -->
              @if (isPriceChangeExam(examInfo.examItem)) {
                <app-tag size="reserveAdd" color="outline-steel">
                  <app-text size="xxs" weight="m" color="steel-500">即將調漲</app-text>
                </app-tag>
              }
            </div>

            <p class="reserve-plan-price">
              @if (!isExamInPackage(examInfo.examItem)) {
              <label>NT$</label>
              {{ examInfo.discountedPrice | numberComma }}
              }@else if (isExamInPackage(examInfo.examItem)) {
              <span class="package-price-text">方案價</span>
              }
            </p>
          </div>
          <div class="reserve-plan-memo-wrapper">
            <p class="reserve-plan-memo" [class.expanded]="expandedMemos.has(examInfo.examItem)"
              [matTooltip]="!isMobile && !expandedMemos.has(examInfo.examItem) && shouldShowReadMore(examInfo.examItem, memoElement) ? examInfo.examMemo : ''"
              [matTooltipDisabled]="isMobile" matTooltipPosition="above" matTooltipClass="memo-tooltip" #memoElement>
              {{ examInfo.examMemo }}

            </p>
            @if (shouldShowReadMore(examInfo.examItem, memoElement)) {
            <button mat-button class="read-more-btn" (click)="toggleMemo($event, examInfo.examItem)">
              <app-text size="special" weight="m" color="primary-700">
                閱讀更多
              </app-text>
              <img [src]="expandedMemos.has(examInfo.examItem) ? 
                                  'assets/img/arrow-up.png' : 
                                  'assets/img/arrow-down.png'" alt="toggle" width="11" height="11" />
            </button>
            }
          </div>

        </div>
        }
        }
        }
        <!-- 查無符合項目處理 -->
        @if (getFilteredExamsCount() === 0) {
        <div class="empty-search-result">
          <span>{{ 'reserve-add.empty-search-result' | translate }}</span>
          <p>{{ 'reserve-add.empty-search-result-description' | translate }}</p>
        </div>
        }
      </div>
      }
    </div>
    } @else {

    <div class="reserve-add-search-block">
      <div class="input-group input-btn-left">
        <input [placeholder]="'reserve-add.quick-search-placeholder' | translate" [(ngModel)]="quickSearchText"
          (ngModelChange)="quickSearchWithText()" />
        <button mat-icon-button type="button" class="input-search-btn">
          <img width="24" height="24" ngSrc="assets/img/i-search-b.svg" alt="" />
        </button>
      </div>

      <div class="input-block">
        <div class="custom-multi-select" [class.open]="isDeptFilterOpen">
          <div class="select-trigger" (click)="toggleDeptFilter()">
            <span class="placeholder">分類篩選</span>
            <div class="trigger-right">
              @if (selectedDeptNames.length > 0) {
              <span class="selected-count">{{ selectedDeptNames.length }}</span>
              }
              <img width="24" height="24"
                [ngSrc]="isDeptFilterOpen ? 'assets/img/i-arrow-up.svg' : 'assets/img/i-arrow-down.svg'" alt="" />
            </div>
          </div>

          @if (isDeptFilterOpen) {
          <div class="select-dropdown">
            <div class="select-header">
              <button mat-button class="clear-all-btn" (click)="clearAllDeptFilters()">
                全部清除
              </button>
            </div>

            <div class="select-options">
              @for (deptName of quickSearchDeptNames; track i; let i = $index) {
              <div class="select-option">
                <mat-checkbox [checked]="selectedDeptNames.includes(deptName)"
                  (change)="toggleDeptFilter(deptName, $event.checked)">
                  {{ deptName }}
                </mat-checkbox>
              </div>
              }
            </div>
          </div>
          }
        </div>
      </div>
    </div>

    <!-- 方案卡片區域 -->
    <div class="reserve-add-card-block">
      @for (deptName of quickSearchDeptNames; track i; let i = $index) {
      @let deptExams = getVisibleExams(getExamInfosByDeptName(deptName));
      @if (deptExams.length > 0 && (selectedDeptNames.length === 0 || selectedDeptNames.includes(deptName))) {
      <div class="reserve-add-category-header margin-top">{{ deptName }}</div>
      @for (examInfo of deptExams; track examInfo.examItem) {
      @if (Number(examInfo.discountedPrice) > 0) {
      <div class="reserve-plan-card" [ngClass]="{
                    active:
                      checkedExamItemSet.has(examInfo.examItem) ||
                      checkedExamItemListUnderPackage.includes(examInfo.examItem),
                    disabled: mutexInfos.has(examInfo.examItem),
                    'active-disabled': isActiveDisabled(
                      examInfo.examItem,
                      examInfo.examType
                    ),
                  }" (click)="
                    !mutexInfos.has(examInfo.examItem) &&
                      toggleChecked(
                        !checkedExamItemSet.has(examInfo.examItem) &&
                          !checkedExamItemListUnderPackage.includes(examInfo.examItem),
                        examInfo
                      )
                    ">
        <!-- 卡牌標題 -->
        <div class="reserve-plan-title">
          <!-- 卡牌checkbox -->
          <div class="reserve-price-block">
            @if (sharedStorageService.get('reserveType') === '1') {
            <!-- 個人預約：非必要檢項或方案內非標準檢項都顯示 checkbox -->
            @if (!examInfo.isNecessary || (examInfo.isNecessary && !examInfo.isChoice && !isFromMemberCenter)) {
            <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)||isMutexWithPackage(examInfo)"
              (change)="toggleChecked($event.checked, examInfo)" [checked]="
                              checkedExamItemSet.has(examInfo.examItem) ||
                              checkedExamItemListUnderPackage.includes(examInfo.examItem)
                            " (click)="$event.stopPropagation()" [ngClass]="{
                              'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                            }">
            </mat-checkbox>
            }
            } @else if (sharedStorageService.get('reserveType') === '2') {
            <!-- 企業預約：非方案內檢項顯示 checkbox -->
            @if (!isExamInPackage(examInfo.examItem)) {
            <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)"
              (change)="toggleChecked($event.checked, examInfo)" [checked]="
                              checkedExamItemSet.has(examInfo.examItem) ||
                              checkedExamItemListUnderPackage.includes(examInfo.examItem)
                            " (click)="$event.stopPropagation()" [ngClass]="{
                              'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                            }">
            </mat-checkbox>
            }
            }
          </div>

          <div class="title-with-tag">
            <h2>{{ examInfo.examName }} </h2>
            @if (isAbnormalExam(examInfo.examItem)) {
            <app-tag size="reserveAdd" color="outline-red">
              <app-text size="xxs" weight="m" color="red-600">個人歷史異常</app-text>
            </app-tag>
            }
            @if (mutexInfos.has(examInfo.examItem)) {
            <app-tag size="reserveAdd" color="outline-gray">
              <app-text size="xxs" weight="m" color="gray-700">檢查意義重複</app-text>
            </app-tag>
            }
            <!-- 調價表tag -->
            @if (isPriceChangeExam(examInfo.examItem)) {
              <app-tag size="reserveAdd" color="outline-steel">
                <app-text size="xxs" weight="m" color="steel-500">即將調漲</app-text>
              </app-tag>
            }
          </div>

          <p class="reserve-plan-price">
            @if (!isExamInPackage(examInfo.examItem)) {
            <label>NT$</label>
            {{ examInfo.discountedPrice | numberComma }}
            }@else if (isExamInPackage(examInfo.examItem)) {
            <span class="package-price-text">方案價</span>
            }
          </p>
        </div>
        <div class="reserve-plan-memo-wrapper">
          <p class="reserve-plan-memo" [class.expanded]="expandedMemos.has(examInfo.examItem)"
            [matTooltip]="!isMobile && !expandedMemos.has(examInfo.examItem) && shouldShowReadMore(examInfo.examItem, memoElement) ? examInfo.examMemo : ''"
            [matTooltipDisabled]="isMobile" matTooltipPosition="above" matTooltipClass="memo-tooltip" #memoElement>
            {{ examInfo.examMemo }}

          </p>
          @if (shouldShowReadMore(examInfo.examItem, memoElement)) {
          <button mat-button class="read-more-btn" (click)="toggleMemo($event, examInfo.examItem)">
            <app-text size="special" weight="m" color="primary-700">
              閱讀更多
            </app-text>
            <img [src]="expandedMemos.has(examInfo.examItem) ? 
                            'assets/img/arrow-up.png' : 
                            'assets/img/arrow-down.png'" alt="toggle" width="11" height="11" />
          </button>
          }
        </div>

      </div>
      }
      }
      }
      }
      <!-- 查無符合項目處理 -->
      @if (getFilteredExamsCount() === 0) {
      <div class="empty-search-result">
        <span>{{ 'reserve-add.empty-search-result' | translate }}</span>
        <p>{{ 'reserve-add.empty-search-result-description' | translate }}</p>
      </div>
      }
    </div>
    }
  </div>

  <!-- 購物車背景遮罩層 -->
  <div class="overlay" [class.active]="isCartOpen" (click)="toggleCart()"></div>

  <!--購物車(方案檢項)-->
  <div class="reserve-add-right-cart" [class.active]="isCartOpen" #reserveAddRightCart>
    <!-- 關閉按鈕-->
    <div class="reserve-add-right-cart-header">
      <button mat-button class="btn-icon-close" (click)="toggleCart()">
        <img width="32" height="32" ngSrc="assets/img/i-close.svg" alt="" />
      </button>
    </div>

    <!-- 已選方案-->
    <div class="reserve-add-right-cart-body">
      <div class="reserve-add-right-cart-title" (click)="isPackageOpen = !isPackageOpen">
        <h2>
          {{ 'reserve-add.selected-package' | translate }} {{ selectedPackage }}
        </h2>
        <button mat-button class="btn-icon">
          <img width="24" height="24" alt="" [ngSrc]="
                isPackageOpen
                  ? 'assets/img/i-arrow-up.svg'
                  : 'assets/img/i-arrow-down.svg'
              " />
        </button>
      </div>

      @if (isPackageOpen) {
      @if (
      this.sharedStorageService.get('reserveType') ===
      ID_LOGIN_TYPE.PERSONAL
      ) {
      <!--個人預約-->
      @for (
      examTypeMap of examInfoListUnderPackageByType.entries();
      track examTypeMap[0]
      ) {
      <div class="reserve-add-right-cart-item">
        @if(examTypeMap[0] !== 'unknown'){
        <h3>{{ examTypeMap[0] }}</h3>
        }

        @for (deptMap of examTypeMap[1]; track deptMap[0]) {
        <div class="reserve-add-right-cart-item-title"
          (click)="toggleDeptOpenStateByExamType(examTypeMap[0], deptMap[0])">
          <h4>{{ deptMap[0] }}</h4>
          <button mat-button class="btn-icon">
            <img width="24" height="24" alt="" [ngSrc]="
                          getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
                            ? 'assets/img/i-arrow-up.svg'
                            : 'assets/img/i-arrow-down.svg'
                        " />
          </button>
        </div>
        @if (getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])) {
        <div class="reserve-add-right-cart-item-block">
          @for (examInfo of deptMap[1]; track examInfo.examItem) {
          <div class="reserve-add-right-cart-checked-item" [ngClass]="{'disabled': mutexInfos.has(examInfo.examItem)}">
            <div>
              <button mat-icon-button type="button" class="btn-icon btn-info" (click)="showExamDialog(examInfo)">
                <img width="14" height="14" ngSrc="assets/img/i-info.svg" alt="" />
              </button>
              <p>{{ examInfo.examName }}</p>
            </div>
            <!-- 不是必檢項目才可以有勾選/取消功能 -->
            @if (
            examInfo.examType !==
            examTypeText[0] && !isPersonal &&
            !examInfo.isNecessary
            ) {
            <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)" [checked]="
                                checkedExamItemListUnderPackage.includes(
                                  examInfo.examItem
                                )
                              " (change)="
                                toggleCheckedUnderPackage(
                                  $event.checked,
                                  examInfo
                                )
                              ">
            </mat-checkbox>
            }
          </div>
          }
        </div>
        }
        }
      </div>
      }
      } @else {
      <!--企業預約-->
      @for (
      examTypeMap of examInfoListUnderPackageByType.entries();
      track examTypeMap[0]
      ) {
      <div class="reserve-add-right-cart-item">
        @if(examTypeMap[0] !== 'unknown'){
        <h3>{{ examTypeMap[0] }}</h3>
        }

        @for (deptMap of examTypeMap[1]; track deptMap[0]) {
        <div class="reserve-add-right-cart-item-title"
          (click)="toggleDeptOpenStateByExamType(examTypeMap[0], deptMap[0])">
          <h4>{{ deptMap[0] }}</h4>
          <button mat-button class="btn-icon">
            <img width="24" height="24" alt="" [ngSrc]="
                          getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
                            ? 'assets/img/i-arrow-up.svg'
                            : 'assets/img/i-arrow-down.svg'
                        " />
          </button>
        </div>
        @if (getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])) {
        <div class="reserve-add-right-cart-item-block">
          @for (examInfo of deptMap[1]; track examInfo.examItem) {
          <div class="reserve-add-right-cart-checked-item" [ngClass]="{'disabled': mutexInfos.has(examInfo.examItem)}">
            <div>
              <button mat-icon-button type="button" class="btn-icon btn-info" (click)="showExamDialog(examInfo)">
                <img width="14" height="14" ngSrc="assets/img/i-info.svg" alt="" />
              </button>
              <p>{{ examInfo.examName }}</p>
            </div>
            <!-- 企業預約的檢項控制 -->
            @if (
            examInfo.examType !==
            examTypeText[0]
            ) {
            <mat-checkbox [disabled]="mutexInfos.has(examInfo.examItem)" [checked]="
                                checkedExamItemListUnderPackage.includes(
                                  examInfo.examItem
                                )
                              " (change)="
                                toggleCheckedUnderPackage(
                                  $event.checked,
                                  examInfo
                                )
                              ">
            </mat-checkbox>
            }
          </div>
          }
        </div>
        }
        }
      </div>
      }
      }
      }

      <!--購物車(加選檢項)-->
      <div class="reserve-add-right-cart-title add-title">
        <h2>{{ 'reserve-add.add-exam-item' | translate }}</h2>
        <div (click)="isAddPackageOpen = !isAddPackageOpen">
          <span>{{ selectedCheckedExamInfoList.length }}</span>
          <button mat-button class="btn-icon">
            <img width="24" height="24" alt="" [ngSrc]="
                  isAddPackageOpen
                    ? 'assets/img/i-arrow-up.svg'
                    : 'assets/img/i-arrow-down.svg'
                " />
          </button>
        </div>
      </div>
      @if (isAddPackageOpen) {
      <div class="reserve-add-right-cart-item-block add-item">
        @if (selectedCheckedExamInfoList.length > 0) {
        @for (
        addExamInfo of selectedCheckedExamInfoList;
        track addExamInfo.examItem
        ) {
        <div class="reserve-add-right-cart-checked-item">
          <div>
            <button mat-icon-button type="button" class="btn-icon btn-info" (click)="showExamDialog(addExamInfo)">
              <img width="14" height="14" ngSrc="assets/img/i-info.svg" alt="" />
            </button>
            <p>{{ addExamInfo.examName }}</p>
          </div>
          <div>
            <p class="reserve-add-item-checked-item">
              <label>$</label> {{ (addExamInfo.discountedPrice ?? addExamInfo.price?.toString()) | numberComma }}
            </p>
            <mat-checkbox (change)="toggleChecked($event.checked, addExamInfo)"
              [checked]="selectedCheckedExamInfoList.includes(addExamInfo)">
            </mat-checkbox>
          </div>
        </div>
        }
        } @else {
        <div class="empty-cart">
          <img width="89" height="78" ngSrc="assets/img/img-empty.svg" alt="" />
          <p>{{ 'reserve-add.empty-items' | translate }}</p>
        </div>
        }
      </div>
      }
    </div>
  </div>

  <!--頁面：固定按鈕區塊-->
  <div class="page-btn-block">
    <div class="btn-group">
      @if (!isPersonal) {
      <button mat-button (click)="resetPackage()" class="btn-outline-primary btn-size-l">
        {{ 'reserve-add.reset-package' | translate }}
      </button>
      }

      <button mat-button (click)="handleNextClick()" class="btn-fill-primary btn-size-l">
        {{ 'common.button.next' | translate }}
      </button>
    </div>

    <div class="page-pay">
      <!-- 企業預約且金額小於0時顯示補助尚餘 -->
      @if (paymentAmount < 0 && sharedStorageService.get('reserveType')===ID_LOGIN_TYPE.ENTERPRISE) { <span>{{
        'reserve-add.subsidy-amount' | translate }}</span>
        } @else {
        <span>{{ 'reserve-add.payment-amount' | translate }}</span>
        }
        @if (paymentAmount < 0 && sharedStorageService.get('reserveType')===ID_LOGIN_TYPE.ENTERPRISE) { <label>NT$
          {{ Math.abs(paymentAmount) | numberComma }}
          </label>
          } @else {
          <label>NT$
            {{ Math.abs(paymentAmount) | numberComma }}
          </label>
          }

          <!--右下角：固定按鈕-->
          <div class="page-btn-fixed">
            <button mat-button class="btn-text-primary" (click)="toggleCart()">
              <span class="cart-text">
                @if (isMobile) {
                檢查清單
                } @else {
                {{ 'reserve-add.show-cart' | translate }}
                }
                <img width="5" height="8" ngSrc="assets/img/Vector-6563.png" alt="">
              </span>
              <!-- @if (checkedExamInfoList.length > 0) {
              <div>
                <span>{{ checkedExamInfoList.length }}</span>
              </div>
            } -->
            </button>
          </div>
    </div>
  </div>
  }
</div>